
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class HsnTaxMasterDialog extends Serenity.EntityDialog<HsnTaxMasterRow, any> {
        protected getFormKey() { return HsnTaxMasterForm.formKey; }
        protected getIdProperty() { return HsnTaxMasterRow.idProperty; }
        protected getLocalTextPrefix() { return HsnTaxMasterRow.localTextPrefix; }
        protected getNameProperty() { return HsnTaxMasterRow.nameProperty; }
        protected getService() { return HsnTaxMasterService.baseUrl; }
        protected getDeletePermission() { return HsnTaxMasterRow.deletePermission; }
        protected getInsertPermission() { return HsnTaxMasterRow.insertPermission; }
        protected getUpdatePermission() { return HsnTaxMasterRow.updatePermission; }

        protected form = new HsnTaxMasterForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.Details);

            //this.form.TaxId.changeSelect2(e => {
            //    this.form.TaxLedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].LedgerId;

            //});
            //this.form.Tax1Id.changeSelect2(e => {
            //    this.form.Tax1LedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.Tax1Id.value].LedgerId;

            //});
            //this.form.Tax2Id.changeSelect2(e => {
            //    this.form.Tax2LedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.Tax2Id.value].LedgerId;

            //});
            //this.form.CessId.changeSelect2(e => {
            //    this.form.CessLedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.CessId.value].LedgerId;

            //});
            //this.form.Cess1Id.changeSelect2(e => {
            //    this.form.Cess1LedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.Cess1Id.value].LedgerId;

            //});



        }

        onDialogOpen() {
            super.onDialogOpen();
            //this.form.TaxGroup.value = Q.Authorization.userDefinition.TaxGroupId.toString();
            //var Country = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].Country;
            //if (Country == "101") {
            //    Serenity.EditorUtils.setRequired(this.form.Tax1Id, true);
            //    Serenity.EditorUtils.setRequired(this.form.Tax2Id, true);
            //}
           //Serenity.EditorUtils.setReadOnly(this.form.TaxGroup, true);
            //if (this.form.Code.value == "") {
            //    this.form.Code.cascadeField = "RateApplied";
            //    this.form.Code.cascadeValue = "false";
            //}
        }
    }
}